import FileSize from "../../../../components/commonComponent/FileSize";
import React from "react";
import { Link } from "react-router";
import styled from "styled-components";
import SiteHeader from "./SiteHeader";
import Footer from "../Footer/Footer";
import Breadcrumb from "../../../about/components/Breadcrumb/Breadcrumb";
import schemeMenuItems from "../../../schemes/data/schemeMenuItems";
import careerMenuItems from "../../../career/data/careerMenuItems";
import complianceMenuItems from "../../../resources/data/complianceMenuItems";
import achievementMenuItems from "../../../achievements/data/achievementMenuItems";

const aboutUsItems = [
  { label: "About NMDFC", path: "/about/about-nmdfc" },
  { label: "Vision & Mission", path: "/about/vision-mission" },
  { label: "Board of Directors", path: "/about/board-directors" },
  { label: "Our Team", path: "/about/our-team" },
  { label: "Organization Chart", path: "/about/organization-chart" },
  { label: "Capital Structure", path: "/about/capital-structure" },
  {
    label: "SCAs & Channelising Partners",
    path: "/about/scas-partners",
  },
  { label: "Target Groups", path: "/about/target-groups" },
  { label: "Media Gallery", path: "/about/events" },
];

const rtiItemsWithHierarchy = [
  {
    label: "Right to Information Act",
    path: "/right-to-information/right-to-information-act",
  
  },
  {
    label: "Parliament Question & Answers",
    path: "/right-to-information/parliament-question-answers",
    subItems: [
      {
        label: "Rajya Sabha",
        path: "/right-to-information/rajya-sabha",
      },
      {
        label: "Lok Sabha",
        path: "/right-to-information/lok-sabha",
      },
    ],
  },
];

const resourceItemsWithHierarchy = [
  {
    label: "Marketing Opportunities for Minority Artisans",
    path: "/resources/marketing-opportunities-for-minority-artisans",
    subItems: [
      {
        label: "Hello Artisans",
        path: "/resources/marketing-opportunities-for-minority-artisans#hello-artisans",
      },
      {
        label: "Meet Our Artisans",
        path: "/resources/marketing-opportunities-for-minority-artisans#meet-our-artisans",
      },
    ],
  },
  {
    label: "Minority Concentrated Blocks",
    path: "/resources/minority-concentrated-blocks",
  },
  {
    label: "Minority Concentrated Districts",
    path: "/resources/minority-concentrated-districts",
  },
  {
    label: "Impact Evaluation Study",
    path: "/resources/impact-evaluation-study",
  },
  {
    label: "Resource Documents",
    path: "/resources/resource-documents",
  },
  {
    label: "KSK Project Details",
    path: "/resources/ksk-project-details",
  },
  {
    label: "FPOs State wise details",
    path: "/resources/fpos-state-wise-details",
  },
  {
    label: "Lending Policy",
    path: "/resources/lending-policy",
  },
];

const quickLinksItemsWithHierarchy = [
  { label: "Home", path: "/" },
  {
    label: "Contact Us",
    path: "/contact",
    subItems: [
      { label: "Grievance Redressal Form", path: "/contact#grievance" },
      { label: "Alumni Network Form", path: "/contact#alumni" },
    ],
  },
  { label: "Frequently Asked Questions", path: "/frequently-asked-questions" },
  { label: "Updates & News", path: "/updates" },
];

const portalItems = [
  {
    label: "Employee Corner",
    path: "/login",
  },
  {
    label: "JanSamarth Portal",
    href: "https://www.jansamarth.in/",
  },
  {
    label: "Ministry of Minority Affairs",
    href: "https://www.minorityaffairs.gov.in/",
  },
  {
    label: "National Portal of India",
    href: "https://www.india.gov.in/",
  },
  {
    label: "Swachh Bharat Mission",
    href: "https://swachhbharatmission.ddws.gov.in/",
  },
];

const sitemapSections = [
  { label: "About Us", path: "/about", items: aboutUsItems },
  { label: "Schemes", path: "/schemes", items: schemeMenuItems },
  {
    label: "Right to Information",
    path: "/right-to-information",
    items: rtiItemsWithHierarchy,
  },
  { label: "Work With Us", path: "/career", items: careerMenuItems },
  {
    label: "Achievements",
    path: "/achievements",
    items: achievementMenuItems,
  },
  {
    label: "Resources",
    path: "/resources",
    items: resourceItemsWithHierarchy,
  },
  { label: "Compliance", path: "/compliance", items: complianceMenuItems },
  { label: "Quick Links", path: null, items: quickLinksItemsWithHierarchy },
  { label: "Important Portals", path: null, items: portalItems },
];

const SitemapPage = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f7f7f7;

  .sitemap-main {
    flex: 1;
    width: 100%;
    max-width: 1480px;
    margin: 0 auto;
    padding: 24px clamp(24px, 5vw, 78px) 58px;
    box-sizing: border-box;
    outline: none;
  }

  .sitemap-breadcrumb {
    position: relative;
    z-index: 1;
    padding: 8px 80px 6px;

    @media (max-width: 768px) {
      padding: 8px 16px 12px;
    }
  }

  .sitemap-title {
    margin: 0 0 24px;
    color: #075b73;
    font-size: clamp(18px, 1.8vw, 25px);
    line-height: 1.2;
    font-weight: 800;
    letter-spacing: 0.02em;
    text-transform: uppercase;

    &::first-letter {
      color: #ff9933;
    }
  }

  .sitemap-grid {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 24px;
  }

  .sitemap-card {
    grid-column: span 3;
    background: #ffffff;
    border: 1px solid #e1e8ed;
    border-radius: 10px;
    padding: 20px 22px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    display: flex;
    flex-direction: column;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 18px rgba(7, 91, 115, 0.08);
      border-color: #cbd5e1;
    }
  }

  .sitemap-card-header {
    margin-bottom: 14px;
    padding-bottom: 8px;
    border-bottom: 2px solid #ff9933;
  }

  .sitemap-section-heading-link,
  .sitemap-section-heading-text {
    color: #075b73;
    font-size: 17px;
    font-weight: 700;
    text-decoration: none;
    display: block;
    line-height: 1.3;
    transition: color 0.15s ease;
  }

  .sitemap-section-heading-link:hover {
    color: #e57d19;
    text-decoration: underline;
  }

  .sitemap-card-list {
    margin: 0;
    padding-left: 18px;
    list-style-type: disc;
    display: flex;
    flex-direction: column;
    gap: 8px;

    li {
      margin: 0;
      line-height: 1.4;
      &::marker {
        color: #075b73;
      }
    }
  }

  .sitemap-sub-list {
    margin: 6px 0 6px 4px;
    padding-left: 12px;
    border-left: 2px dashed #93c5fd;
    display: flex;
    flex-direction: column;
    gap: 6px;
    list-style-type: none;

    li {
      position: relative;
      padding-left: 8px;

      &::marker {
        content: "";
      }

      &::before {
        content: "";
        position: absolute;
        left: -12px;
        top: 9px;
        width: 8px;
        height: 2px;
        background-color: #93c5fd;
      }
    }
  }

  .sitemap-link {
    color: #164c86;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    transition: color 0.15s ease, text-decoration-color 0.15s ease;
  }

  .sitemap-link:hover,
  .sitemap-link:focus-visible {
    color: #e57d19;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  .sitemap-sub-link {
    color: #1e3a8a;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    transition: color 0.15s ease;

    &:hover,
    &:focus-visible {
      color: #e57d19;
      text-decoration: underline;
    }
  }

  .sitemap-footer {
    margin-top: 0;
  }

  @media (max-width: 1100px) {
    .sitemap-card {
      grid-column: span 6;
    }
  }

  @media (max-width: 640px) {
    .sitemap-main {
      padding: 18px 18px 36px;
    }

    .sitemap-grid {
      gap: 16px;
    }

    .sitemap-card {
      grid-column: span 12;
      padding: 16px;
    }
  }
`;

const SitemapItemLink = ({ item }) => {
  if (item.href) {
    return (
      <a
        className="sitemap-link"
        href={item.href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {item.label}<FileSize href={item.href} />
      </a>
    );
  }
  return (
    <Link className="sitemap-link" to={item.path}>
      {item.label}
    </Link>
  );
};

const SitemapSubItemLink = ({ item }) => {
  if (item.href) {
    return (
      <a
        className="sitemap-sub-link"
        href={item.href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {item.label}<FileSize href={item.href} />
      </a>
    );
  }
  return (
    <Link className="sitemap-sub-link" to={item.path}>
      {item.label}
    </Link>
  );
};

const SectionHeading = ({ section }) => {
  if (section.path) {
    return (
      <Link className="sitemap-section-heading-link" to={section.path}>
        {section.label}
      </Link>
    );
  }
  return <span className="sitemap-section-heading-text">{section.label}</span>;
};

const Sitemap = () => (
  <SitemapPage>
    <SiteHeader>
      <div className="sitemap-breadcrumb">
        <Breadcrumb
          items={[
            { label: "Home", path: "/" },
            { label: "Sitemap", path: "/sitemap" },
          ]}
        />
      </div>
    </SiteHeader>

    <main
      id="main-content"
      className="sitemap-main"
      data-readable-content
      tabIndex={-1}
    >
      <h1 className="sitemap-title">Sitemap</h1>

      <div className="sitemap-grid">
        {sitemapSections.map((section) => (
          <div key={section.label} className="sitemap-card">
            <div className="sitemap-card-header">
              <SectionHeading section={section} />
            </div>
            <ul className="sitemap-card-list">
              {section.items.map((item) => (
                <li key={item.label}>
                  <SitemapItemLink item={item} />
                  {item.subItems && item.subItems.length > 0 && (
                    <ul className="sitemap-sub-list">
                      {item.subItems.map((subItem) => (
                        <li key={subItem.label}>
                          <SitemapSubItemLink item={subItem} />
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </main>

    <div className="sitemap-footer">
      <Footer />
    </div>
  </SitemapPage>
);

export default Sitemap;

